import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getTipoDeContrato } from "../../../actions/dummy-actions";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStateValue } from "../../../context/store";
import { styleSearch } from "./styles";
import { defaultSearchValues } from "./models";

const ContractTypeSearch = (props) => {
  //const _ = require("lodash");
  const classes = styleSearch();
  const [{}, dispatch] = useStateValue();
  const [resetAutocomplete, setResetAutocomplete] = useState(false);

  const schema = yup.object().shape({
    contractType: yup.object().when([], {
      is: (contractType) => contractType && contractType.length > 0,
      then: yup.object(),
      otherwise: yup
        .object()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
    status: yup.string().when([], {
      is: (status) => status && status.length > 0,
      then: yup.string(),
      otherwise: yup
        .string()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),
  });

  const { register, handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultSearchValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    data.contractType = data.contractType ? data.contractType.key : null;
    if (data.contractType !== null || data.status !== null) {
      dispatch({
        type: "SET_CONTRACT_TYPE_FILTER",
        filter: data,
        isFilter: true,
      });
    } else {
      dispatch({
        type: "SET_CONTRACT_TYPE_FILTER",
        filter: {
          contractType: null,
          status: null,
        },
        isFilter: true,
      });
    }
  };

  const clearForm = () => {
    setValue("contractType", null);
    setValue("status", null);
    setResetAutocomplete(!resetAutocomplete);
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_CONTRACT_TYPE_FILTER",
      filter: {
        contractType: null,
        status: null,
      },
      isFilter: true,
    });
  };

  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={2} lg={3}>
          <FormControl fullWidth>
            <Controller
              render={(props) => (
                <Autocomplete
                  {...props}
                  size="small"
                  key={resetAutocomplete}
                  options={getTipoDeContrato()}
                  className={classes.formField}
                  getOptionLabel={(option) => option.name}
                  renderOption={(option) => <span>{option.name}</span>}
                  defaultValue={props.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Nombre tipo de contrato"
                      variant="outlined"
                      className={classes.dropdown}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          height: "12px",
                          borderRadius: "8px",
                          paddingBottom: "9.5px",
                        },
                      }}
                      error={
                        !!errors.hasOwnProperty("contractType") &&
                        errors["contractType"].message
                      }
                      helperText={
                        errors.hasOwnProperty("contractType") &&
                        errors["contractType"].message
                      }
                    />
                  )}
                  onChange={(_, data) => {
                    props.onChange(data);
                  }}
                />
              )}
              name="contractType"
              control={control}
            />
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          md={1}
          lg={1}
          style={{
            width: "100%",
            textAlign: "center",
            verticalAlign: "center",
            paddingTop: "12px",
          }}
        >
          <span>Filtrar:</span>
        </Grid>

        <Grid item xs={12} md={1} lg={1}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("status") && errors["status"].message
            }
          >
            <InputLabel
              htmlFor="outlined-select-status"
              shrink={true}
              size="small"
            >
              Estado
            </InputLabel>
            <Controller
              fullWidth
              control={control}
              inputRef={register}
              className={classes.dropdown}
              label="Estado"
              size="small"
              name="status"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "status",
                id: "outlined-select-status",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  <MenuItem value="Activo">Activo</MenuItem>
                  <MenuItem value="Inactivo">Inactivo</MenuItem>
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("status") && errors["status"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
          >
            Buscar
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            className={classes.buttonSearch}
            onClick={clearBtn}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ContractTypeSearch;
